function Logo() {
    return (
      <div style={{fontSize: "50px"}}>
        <b class="logo" >Jack Ribarich</b>
      </div>
    );
  }

  export default Logo;